export const palette = {
    primary: { main: "#3C3B6E" },
    secondary: { main: "#B22234" },
};
export const darkPalette = {
    type: "dark",
};
//# sourceMappingURL=palette.js.map